// function appendWishlistMetafields() {
//     const wishlistProducts = document.querySelectorAll(".iwishProduct-row");
//     console.log("Wishlist Products:", wishlistProducts.length);
//     if (!wishlistProducts.length) return;
//     wishlistProducts.forEach(async (product) => {
//         if (product.querySelector(".wishlist-pincode-container")) return;
//         const handle = product.querySelector("[data-handle]")?.dataset.handle;
//         if (!handle) return;
//         try {
//             const response = await fetch(`/products/${handle}`);
//             const html = await response.text();
//             const parser = new DOMParser();
//             const doc = parser.parseFromString(html, "text/html");
//             const pincodeEl = doc.querySelector(".pincode_checker_msg");
//             if (!pincodeEl) return;
//             const wrapper = document.createElement("div");
//             wrapper.className = "wishlist-pincode-container";
//             wrapper.innerHTML = pincodeEl.outerHTML;
//             product.querySelector(".price_Container")?.after(wrapper);
//         } catch (e) {
//             console.error(e);
//         }
//     });
// }

// function attach_atc_event() {
//   document.addEventListener(
//     'click',
//     async function (event) {
//       const singleBtn = event.target.closest('.iwish-cartQty .add_to_cart');
//       const addAllBtn = event.target.closest('.addToCart-btn');

//       if (!singleBtn && !addAllBtn) return;

//       event.preventDefault();
//       event.stopImmediatePropagation();

//       /*
//        * ADD SINGLE PRODUCT
//        */
//       if (singleBtn) {
//         const row = singleBtn.closest('.iwishProduct-row');

//         if (!row) return;

//         const variantId = (row.id || '').replace('product_var', '');

//         if (!variantId || !/^\d+$/.test(variantId)) {
//           console.error('Variant ID not found');
//           return;
//         }

//         const eddElement = row.querySelector('.wishlist-edd');

//         let edd = '';

//         if (eddElement) {
//           edd = eddElement.textContent.split(':').slice(1).join(':').trim();
//         }

//         const btnText = singleBtn.querySelector('span');
//         const originalText = btnText?.textContent || 'Add To Cart';

//         singleBtn.disabled = true;

//         if (btnText) {
//           btnText.textContent = 'Adding...';
//         } else {
//           singleBtn.textContent = 'Adding...';
//         }

//         try {
//           const response = await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//               'Accept': 'application/json'
//             },
//             body: JSON.stringify({
//               items: [
//                 {
//                   id: Number(variantId),
//                   quantity: 1,
//                   properties: {
//                     "Estimated Delivery": edd
//                   }
//                 }
//               ]
//             })
//           });

//           if (!response.ok) {
//             throw new Error('Failed to add product');
//           }

//           const data = await response.json();

//           console.log('Product added:', data);

//           if (btnText) {
//             btnText.textContent = 'Added';
//           } else {
//             singleBtn.textContent = 'Added';
//           }

//           document.dispatchEvent(new CustomEvent("cart:refresh"));

//           setTimeout(() => {
//             if (btnText) {
//               btnText.textContent = originalText;
//             } else {
//               singleBtn.textContent = originalText;
//             }

//             singleBtn.disabled = false;
//           }, 2000);

//         } catch (error) {
//           console.error('Add to cart error:', error);

//           if (btnText) {
//             btnText.textContent = originalText;
//           } else {
//             singleBtn.textContent = originalText;
//           }

//           singleBtn.disabled = false;
//         }

//         return;
//       }

//       /*
//        * ADD ALL PRODUCTS
//        */
//       if (addAllBtn) {
//         const rows = document.querySelectorAll(
//           '.iwish-row.iwishProduct-row'
//         );

//         if (!rows.length) {
//           console.error('No wishlist products found');
//           return;
//         }

//         const items = [];

//         rows.forEach((row) => {
//           const variantId = (row.id || '').replace('product_var', '');

//           if (!variantId || !/^\d+$/.test(variantId)) {
//             return;
//           }

//           const eddElement = row.querySelector('.wishlist-edd');

//           let edd = '';

//           if (eddElement) {
//             edd = eddElement.textContent.split(':').slice(1).join(':').trim();
//           }

//           items.push({
//             id: Number(variantId),
//             quantity: 1,
//             properties: {
//               "Estimated Delivery": edd
//             }
//           });
//         });

//         if (!items.length) {
//           console.error('No valid products found');
//           return;
//         }

//         const originalText = addAllBtn.textContent.trim();

//         addAllBtn.disabled = true;
//         addAllBtn.textContent = 'Adding...';

//         try {
//           const response = await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//               'Accept': 'application/json'
//             },
//             body: JSON.stringify({
//               items: items
//             })
//           });

//           if (!response.ok) {
//             throw new Error('Failed to add products');
//           }

//           const data = await response.json();

//           console.log('All wishlist products added:', data);

//           addAllBtn.textContent = 'Added to cart';

//           document.dispatchEvent(new CustomEvent("cart:refresh"));

//           setTimeout(() => {
//             addAllBtn.textContent = originalText;
//             addAllBtn.disabled = false;
//           }, 2000);

//         } catch (error) {
//           console.error('Add all to cart error:', error);

//           addAllBtn.textContent = originalText;
//           addAllBtn.disabled = false;
//         }
//       }
//     },
//     true
//   );
// }


// function drawerInitCallback() {
//     let count = 0;
//     const interval = setInterval(() => {
//         const wishlistProducts = document.querySelectorAll(".iwishProduct-row");
//         if (wishlistProducts.length) {
//             clearInterval(interval);
//             // appendWishlistMetafields();
//             attach_atc_event();
//         }
//         if (++count > 20) {
//             clearInterval(interval);
//         }
//     }, 500);
// }


function init_current_viewer_count() {
  const viewerElements = document.querySelectorAll('.current_viewer_count');

  if (!viewerElements.length) return;

  const productId = ShopifyAnalytics?.meta?.product?.id;

  if (!productId) return;

  const storageKey = `dd_viewer_count_${productId}`;
  const currentTime = Date.now();
  const holdTime = 2 * 60 * 1000;

  let viewerData = null;

  try {
    viewerData = JSON.parse(localStorage.getItem(storageKey));
  } catch (error) {
    viewerData = null;
  }

  let viewerCount;

  if (
    viewerData &&
    viewerData.count &&
    viewerData.timestamp &&
    currentTime - viewerData.timestamp < holdTime
  ) {
    viewerCount = viewerData.count;
  } else {
    viewerCount = Math.floor(Math.random() * 41) + 10;

    localStorage.setItem(
      storageKey,
      JSON.stringify({
        count: viewerCount,
        timestamp: currentTime
      })
    );
  }

  viewerElements.forEach((element) => {
    element.textContent = `${viewerCount} people are viewing this item. Don’t wait!`;
  });
}
if(__st.p == "product"){
  init_current_viewer_count();
}



